import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { matchingApi } from '../api/matching';
import { ProfileWithUser } from '../types';
import { ProfileCard } from '../components/ProfileCard';
import { MatchModal } from '../components/MatchModal';
import './Home.css';

export const Home: React.FC = () => {
  const [recommendations, setRecommendations] = useState<ProfileWithUser[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isMatchModalVisible, setIsMatchModalVisible] = useState(false);
  const [matchedUser, setMatchedUser] = useState<ProfileWithUser | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadRecommendations();
  }, []);

  const loadRecommendations = async () => {
    try {
      const data = await matchingApi.getRecommendations();
      setRecommendations(data);
    } catch (error: any) {
      console.error('Failed to load recommendations:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSwipe = async (action: 'like' | 'dislike') => {
    const currentUser = recommendations[currentIndex];
    if (!currentUser) return;

    try {
      const result = await matchingApi.swipe(currentUser.userId, action);

      if (result.isMatch && result.matchedUser) {
        setMatchedUser(result.matchedUser as ProfileWithUser);
        setIsMatchModalVisible(true);
      }

      setCurrentIndex((prev) => prev + 1);
    } catch (error: any) {
      console.error('Swipe error:', error);
      setCurrentIndex((prev) => prev + 1);
    }
  };

  const handleLike = () => handleSwipe('like');
  const handleDislike = () => handleSwipe('dislike');

  const handleSendMessage = () => {
    setIsMatchModalVisible(false);
    navigate('/matches');
  };

  const handleKeepSwiping = () => {
    setIsMatchModalVisible(false);
    setMatchedUser(null);
  };

  if (isLoading) {
    return (
      <div className="home-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  const currentProfile = recommendations[currentIndex];

  return (
    <div className="home-container">
      <div className="home-content">
        {currentProfile ? (
          <>
            <div className="card-container">
              <ProfileCard profile={currentProfile} />
            </div>

            <div className="swipe-actions">
              <button 
                className="action-button dislike-button"
                onClick={handleDislike}
                aria-label="Dislike"
              >
                ✕
              </button>
              <button 
                className="action-button like-button"
                onClick={handleLike}
                aria-label="Like"
              >
                ♥
              </button>
            </div>
          </>
        ) : (
          <div className="no-more-profiles">
            <h2>No more profiles</h2>
            <p>Check back later for more recommendations!</p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/matches')}
            >
              View Matches
            </button>
          </div>
        )}
      </div>

      <MatchModal
        isVisible={isMatchModalVisible}
        matchedUser={matchedUser}
        onSendMessage={handleSendMessage}
        onKeepSwiping={handleKeepSwiping}
      />
    </div>
  );
};
